/**
 * A player's QR code is their profile URL, so reading one means pulling the id
 * out of a path: `/player/<uuid>`, with or without a host in front.
 *
 * In one place because it is a wire format shared by whatever prints the code
 * and everything that scans it. It was inline in the attendance scanner, and a
 * second copy in a second scanner is how two screens come to disagree about
 * which codes are valid.
 */
export const playerIdFromQr = (text) => {
  const match = String(text || '').match(/\/player\/([a-zA-Z0-9-]{8,})/);
  return match ? match[1] : null;
};

export default playerIdFromQr;
